// The app mark, drawn from the one SVG the icons are also generated from.
//
// It is an `<img>` rather than inline SVG on purpose: the artwork lives in
// `src/assets/logo.svg` and carries its own styles, so there is exactly one
// copy of the drawing. Inlining it would mean a second transcription that can
// drift from the file the icons are built from.
//
// Decorative by default — the wordmark next to it already names the app, and an
// image reading "Sensing" beside the text "Sensing" is noise for a screen
// reader. Pass `label` only where the mark stands alone.

import type { ReactNode } from 'react';
import logoUrl from '@/assets/logo.svg';

export interface LogoProps {
  /** Edge length in pixels; the artwork is square. */
  size?: number;
  /** Accessible name. Omitted, the mark is hidden from assistive technology. */
  label?: string;
}

/** The Sensing app mark. */
export function Logo({ size = 28, label }: LogoProps): ReactNode {
  return (
    <img
      src={logoUrl}
      width={size}
      height={size}
      alt={label ?? ''}
      {...(label ? { role: 'img' } : { 'aria-hidden': true })}
      style={{ display: 'block', flexShrink: 0, borderRadius: Math.round(size / 5) }}
    />
  );
}
